import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import {
  LinearProgress,
  FormControl,
  SelectProps,
  MenuItem,
  Switch,
  Select,
} from '@mui/material';
import { IAppState } from '../../../../state/reducers';
import {
  IProps,
  IStateProps,
  IDispatchProps,
} from './interfaces';
import {
  fetchContentPreferences,
  updateMovFormatEnabled,
  updateExchangeFileDownloadDisabled,
  saveContentPreferences,
  toggleContentPreferences,
  updateIsFirstAvailableOnly,
  updateIsPushToCloud,
} from '../../../../state/exchange/contentPreferences';
import {
  DialogHeader,
  DialogHeaderTitle,
  ActionContainer,
} from '../../../Shared/styles/dialog';
import { VaultButton } from '../../../Shared';
import {
  ProgressContainer,
  FormRow,
  FormLabel,
  InputContainer,
  StyledDialogActionsOverride,
} from './styles';
import { selectUserOrgsSecurityProfiles } from '../../../../state/user/userOrgRole';
import { isFootball, isHockey } from '../../../../utils/exchange';

const selectProps: SelectProps = {
  MenuProps: {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center',
    },
  },
};

class ContentPreferences extends React.Component<IProps> {
  componentDidMount() {
    const { onFetchPreferences } = this.props;
    onFetchPreferences();
  }

  render() {
    const {
      isLoading,
      isLoaded,
      movFormatEnabled,
      exchangeFileDownloadDisabled,
      securityProfiles,
      isPushToCloud,
      isFirstAvailableOnly,
      sport,
      onMovFormatChange,
      onExchangeFileDownloadDisabledChange,
      onFirstAvailableOnlyChange,
      onPushToCloudChange,
      onSave,
      onClose,
    } = this.props;

    const hasThunderOrg = securityProfiles.some(({ thunderOrg_id }) => !!thunderOrg_id);
    const deliveryMethods = ['Console Download', 'ThunderCloud'];
    const isPushToCloudString = isPushToCloud ? deliveryMethods[1] : deliveryMethods[0];

    return (
      <>
        <DialogHeader>
          <DialogHeaderTitle data-auto="ContentPreferencesTitle">
            Content Preferences
          </DialogHeaderTitle>
        </DialogHeader>
        <ProgressContainer>
          {isLoading && <LinearProgress />}
        </ProgressContainer>
        {isLoaded && (
          <>
            {hasThunderOrg && (
              <FormRow>
                <FormLabel>Content Delivery Method</FormLabel>
                <InputContainer>
                  <FormControl variant="outlined">
                    <Select
                      data-tip="Select Content Preferences"
                      {...selectProps}
                      labelId="deliveryLabel"
                      value={isPushToCloudString}
                      onChange={(e) => onPushToCloudChange(e.target.value === deliveryMethods[1])}
                      variant="outlined"
                    >
                      <MenuItem
                        data-option="ConsoleDownload"
                        value={deliveryMethods[0]}
                      >
                        Console Download
                      </MenuItem>
                      <MenuItem
                        data-option="ThunderCloud"
                        value={deliveryMethods[1]}
                      >
                        ThunderCloud
                      </MenuItem>
                    </Select>
                  </FormControl>
                </InputContainer>
              </FormRow>
            )}
            {isFootball(sport)
              && (
                <FormRow>
                  <FormLabel style={{ cursor: 'pointer' }} onClick={() => onFirstAvailableOnlyChange(!isFirstAvailableOnly)}>First Available Only</FormLabel>
                  <InputContainer>
                    <Switch color="primary" checked={isFirstAvailableOnly} onChange={(e) => onFirstAvailableOnlyChange(e.target.checked)} data-tip="FirstAvailableOnly" data-value={isFirstAvailableOnly} />
                  </InputContainer>
                </FormRow>
              )}
            {isHockey(sport) && (
              <FormRow>
                <FormLabel style={{ cursor: 'pointer' }} onClick={() => onMovFormatChange(!movFormatEnabled)}>Mov Format Enabled</FormLabel>
                <InputContainer>
                  <Switch color="primary" checked={movFormatEnabled} onChange={(e) => onMovFormatChange(e.target.checked)} />
                </InputContainer>
              </FormRow>
            )}
            <FormRow>
              <FormLabel style={{ cursor: 'pointer' }} onClick={() => onExchangeFileDownloadDisabledChange(!exchangeFileDownloadDisabled)}>Exchange File Download Disabled</FormLabel>
              <InputContainer>
                <Switch
                  color="primary"
                  checked={exchangeFileDownloadDisabled}
                  onChange={(e) => onExchangeFileDownloadDisabledChange(e.target.checked)}
                  data-tip="ExchangeFileDownloadDisabled"
                  data-value={exchangeFileDownloadDisabled}
                />
              </InputContainer>
            </FormRow>
          </>
        )}
        <StyledDialogActionsOverride disableSpacing>
          <ActionContainer>
            <VaultButton
              variant="plainOnPaper"
              onClick={onClose}
              data-auto="CancelBtn"
            >
              Cancel
            </VaultButton>
            <VaultButton
              variant="primaryOnWhite"
              onClick={() => { onSave(); onClose(); }}
              data-auto="SaveBtn"
            >
              Save
            </VaultButton>
          </ActionContainer>
        </StyledDialogActionsOverride>
      </>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  isLoading: state.exchange?.contentPreferences?.isLoading ?? false,
  isLoaded: state.exchange?.contentPreferences?.isLoaded ?? false,
  movFormatEnabled: state.exchange?.contentPreferences?.movFormatEnabled ?? false,
  exchangeFileDownloadDisabled: state.exchange?.contentPreferences?.exchangeFileDownloadDisabled ?? false,
  securityProfiles: selectUserOrgsSecurityProfiles(state),
  isFirstAvailableOnly: state.exchange?.contentPreferences?.subscription?.isFirstAvailableOnly ?? false,
  isPushToCloud: state.exchange?.contentPreferences?.subscription?.isPushToCloud ?? false,
  sport: state.exchange?.initExchange?.sport ?? '',
});

const mapDispatchToProps: IDispatchProps = {
  onFetchPreferences: fetchContentPreferences,
  onMovFormatChange: updateMovFormatEnabled,
  onExchangeFileDownloadDisabledChange: updateExchangeFileDownloadDisabled,
  onFirstAvailableOnlyChange: updateIsFirstAvailableOnly,
  onPushToCloudChange: updateIsPushToCloud,
  onSave: saveContentPreferences,
  onClose: toggleContentPreferences,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContentPreferences);
